import * as React from "react";

import { Box, makeStyles, Theme, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
  bulletCircle: {
    width: "8px",
    height: "8px",
    backgroundColor: theme.palette.common.black,
    borderRadius: "50%",
    marginRight: theme.spacing(2),
  },
}));

export const ListItem: React.FC = ({ children }) => {
  const classes = useStyles();
  return (
    <Box display="flex" mb={1.5} alignItems="center">
      <Box className={classes.bulletCircle} component="span" />
      <Typography variant="body2">{children}</Typography>
    </Box>
  );
};
